import { useId, useMemo, useState } from 'react';
import { Icon } from './Icon';

interface TagInputProps {
  value: readonly string[];
  knownTags: readonly string[];
  onChange: (tags: string[]) => void;
}

function cleanTag(value: string): string {
  return value.trim().replace(/\s+/g, ' ');
}

export function TagInput({ value, knownTags, onChange }: TagInputProps) {
  const listId = useId();
  const [text, setText] = useState('');
  const [focused, setFocused] = useState(false);

  const suggestions = useMemo(() => {
    const query = cleanTag(text).toLocaleLowerCase('ru');
    return knownTags.filter((tag) => {
      const lower = tag.toLocaleLowerCase('ru');
      return !value.some((chosen) => chosen.toLocaleLowerCase('ru') === lower) && (!query || lower.includes(query));
    }).slice(0, 7);
  }, [knownTags, text, value]);

  const add = (raw: string) => {
    const tag = cleanTag(raw);
    if (!tag) return;
    if (!value.some((item) => item.toLocaleLowerCase('ru') === tag.toLocaleLowerCase('ru'))) onChange([...value, tag]);
    setText('');
  };

  return (
    <div className="tag-editor">
      {value.length > 0 ? (
        <div className="tag-editor__chips" aria-label="Выбранные теги">
          {value.map((tag) => (
            <span className="tag-chip tag-chip--removable" key={tag}>
              {tag}
              <button
                className="tag-chip__remove"
                type="button"
                aria-label={`Удалить тег «${tag}»`}
                onClick={() => onChange(value.filter((item) => item !== tag))}
              >
                <Icon name="close" />
              </button>
            </span>
          ))}
        </div>
      ) : null}
      <div className="tag-editor__row">
        <input
          className="field-input"
          value={text}
          placeholder="Например, завтрак"
          aria-controls={listId}
          aria-expanded={focused && suggestions.length > 0}
          onFocus={() => setFocused(true)}
          onBlur={() => window.setTimeout(() => setFocused(false), 120)}
          onChange={(event) => setText(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ',') {
              event.preventDefault();
              add(text);
            }
          }}
        />
        <button className="button button--secondary" type="button" disabled={!cleanTag(text)} onClick={() => add(text)}>
          Добавить
        </button>
      </div>
      {focused && suggestions.length > 0 ? (
        <ul className="tag-suggestions" id={listId}>
          {suggestions.map((tag) => (
            <li key={tag}>
              <button className="tag-suggestion" type="button" onMouseDown={(event) => event.preventDefault()} onClick={() => add(tag)}>
                {tag}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
      <p className="field-hint">Введите тег и нажмите «Добавить» или Enter.</p>
    </div>
  );
}
